import { render, staticRenderFns } from "./TermsFooter.vue?vue&type=template&id=19fbb557&scoped=true&"
import script from "./TermsFooter.vue?vue&type=script&lang=ts&"
export * from "./TermsFooter.vue?vue&type=script&lang=ts&"
import style0 from "./TermsFooter.vue?vue&type=style&index=0&id=19fbb557&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fbb557",
  null
  
)

export default component.exports